export class GitHubCommonUtil {
  static OBTAIN_TOKEN_URL = "https://github.com/settings/tokens/new?scopes=repo,admin:repo_hook,admin:public_key,read:org,user:email"

  private static GITHUB_HTTPS_URL_PATTERN = /^https:\/\/github\.com\/(.*?)\/(.*?)(\.git|\/.*)?$/
  private static GITHUB_SSH_URL_PATTERN = /^git@github\.com:(.*?)\/(.*?)\.git$/

  static isGitHubRepository(url: string): boolean {
    return this.parse(url) !== null
  }

  static parse(url: string): GitHubRepoName | null {
    const httpsMatch = this.GITHUB_HTTPS_URL_PATTERN.exec(url)
    if (httpsMatch) {
      return { owner: httpsMatch[1], repository: httpsMatch[2] }
    }

    const sshMatch = this.GITHUB_SSH_URL_PATTERN.exec(url)
    if (sshMatch) {
      return { owner: sshMatch[1], repository: sshMatch[2] }
    }

    return null
  }
}

interface GitHubRepoName {
  owner: string
  repository: string
}
